import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import hero from "../assets/Airport_Transfers.png";

function AirportTransfer() {

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    const transfers = [
        { route: "Ahangama ↔ Airport / Negombo", car: "Rs. 20,000", van: "Rs. 28,000" },
        { route: "Colombo ↔ Ahangama", car: "Rs. 19,000", van: "Rs. 27,000" },
        { route: "Galle ↔ Airport", car: "Rs. 18,000", van: "Rs. 25,000" },
        { route: "Matara ↔ Airport", car: "Rs. 24,000", van: "Rs. 30,000" },
        { route: "Weligama ↔ Airport", car: "Rs. 22,000", van: "Rs. 29,000" },
        { route: "Kandy ↔ Airport", car: "Rs. 25,000", van: "Rs. 30,000" },
        { route: "Sigiriya ↔ Airport", car: "Rs. 35,000", van: "Rs. 40,000" },
        { route: "Arugam Bay ↔ Airport", car: "Rs. 45,000", van: "Rs. 55,000" },
    ];

    return (
        <div className="w-full">

            {/* ================= HERO SECTION ================= */}
            <section className="relative h-[40vh] w-full">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${hero})` }}
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center text-white">
                    <h1 className="mb-4 text-4xl font-extrabold sm:text-5xl md:text-6xl">
                        Airport Transfer
                    </h1>
                    <p className="max-w-2xl text-sm text-gray-200 sm:text-base">
                        Reliable, comfortable, and fixed-price airport pickup & drop services islandwide.
                    </p>
                </div>
            </section>

            {/* CONTENT */}
            <section className="py-14 bg-white">
                <div className="max-w-6xl mx-auto px-4">

                    {/* INTRO */}
                    <div data-aos="fade-up" className="text-center mb-10">
                        <h2 className="text-3xl font-bold mb-3">Fixed Pricing</h2>
                        <p className="text-gray-600">
                            Transparent rates based on route and vehicle type. No hidden charges.
                        </p>
                    </div>

                    {/* VEHICLES */}
                    <div
                        data-aos="fade-up"
                        className="bg-gray-100 p-6 rounded-lg mb-10"
                    >
                        <h3 className="text-xl font-semibold mb-4">Vehicles</h3>

                        <ul className="space-y-2 text-gray-700">
                            <li>🚗 Car: Up to 3 people</li>
                            <li>🚐 Van: 3–6 people with luggage</li>
                        </ul>
                    </div>

                    {/* TABLE */}
                    <div data-aos="fade-up">
                        <h3 className="text-2xl font-bold mb-6 text-center">
                            Transfer Rates (Car / Van)
                        </h3>

                        <div className="overflow-x-auto">
                            <table className="w-full border border-gray-200 rounded-lg overflow-hidden">
                                <thead className="bg-black text-white">
                                    <tr>
                                        <th className="p-3 text-left">Route</th>
                                        <th className="p-3">Car</th>
                                        <th className="p-3">Van</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {transfers.map((item, index) => (
                                        <tr
                                            key={index}
                                            className="border-t text-center hover:bg-gray-50"
                                        >
                                            <td className="p-3 text-left">{item.route}</td>
                                            <td className="p-3 font-semibold">{item.car}</td>
                                            <td className="p-3 font-semibold">{item.van}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* CTA */}
                    <div
                        data-aos="fade-up"
                        className="mt-12 text-center"
                    >
                        <a
                            href="https://wa.me/94769245905"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-green-500 text-black px-6 py-3 rounded-lg font-semibold hover:bg-green-600 transition"
                        >
                            📲 Book via WhatsApp
                        </a>
                    </div>

                </div>
            </section>

        </div>
    );
}

export default AirportTransfer;